import { ISoundConfig } from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";

export class SoundConfig implements ISoundConfig {

    public static instance:SoundConfig = new SoundConfig();

    /*
    BONUS_END:AudioConfig = {
        Play:{
            Sounds: ["reelsSpinning", "shootWindow"],
            Volume:1,
        },
        Fade:{
            Sounds:["shootWindow","shootWindow3"],
            StartVolume:1,
            EndVolume:0,
            FadeDuration: 300 (ms), | not defined = sound duration.
        },
        Stop:{
            Sounds:["pling","endcount"],
            FadeDuration: 200,
        }
    }
    */



    BASE_GAME_AMBIANCE:string = "background-music-main1";
    BASE_GAME_AMBIANCE2:string = "background-music-main2";
    FS_GAME_AMBIANCE:string = "background-music-fs";

    MANIAC_1:string = "psycho-manhunt1";
    MANIAC_2:string = "psycho-manhunt2";

    INTRO_FOLDER:string = "introFolder";

    REELS_SPINNING:string = "reelsSpinning";
    REELS_DEFAULT_BOUNCE:string[] = ["reelLanding"];
    BAR_LANDING_BOUNCE:string = "fsTopBotReelLanding";
    

    FS_INTRO:string = "fsIntro";

    FS_MYSTERY_REVEAL:string = "fsRevealSymbols";

    FS_JAIL_DOOR_OPEN:string = "fsJailDoorsOpen";
    FS_JAIL_DOOR_CLOSE:string = "fsJailDoorsClose";

    FS_BLACKBOARD_STROKE:string = "fsBlackboard";
    FS_CHAR_IN:string = "fsCharacterIn";

    FS_TOTAL_SPINS:string = "fsTotalSpins";

    FS_MULT_TURN:string = "fsMultiplierTurn";

    FS_LINE_FIRE:string = "fsFire";
    
    FS_JUMPINGWILD_MOVE:string = "fsJumpingWildMove";
    FS_JUMPINGWILD_IN:string = "fsJumpingWildIn";

    FS_POLICE_IN:string = "fsPoliceIn";
    FS_POLICE_SWITCH:string = "fsCharacterInPolice";

    FS_MULTIPLIER_COLLECT:string = "fsMultiplierCollect";
    FS_MULTIPLIER_MOVE_DOWN:string = "fsMultiplierMoveDown";

    FS_ENDS:string = "fsEnds";

    BG_GOING_DOWN:string = "fsDown";
    BG_GOING_UP:string = "fsUp";

    BAR_OPEN:string = "jailDoorOpen";

    BIG_WIN_INIT:string = "bigwinInitialWin";
    BIG_WIN_INIT_COUNTUP:string = "bigwinInitialCountup";
    
    BIG_WIN_COUNT:string = "bigwinCountup";

    BIG_WIN_LVL:string = "bigwinLevel"; // Usng 1-5;
    BIG_WIN_ENDS:string = "bigwinEnds"; 
    BIG_WIN_EXPLODE:string = "bigwinLevel5Explode"; 
    BIG_WIN_ATTENTION:string = "bigwinAnticipation";
    BIG_WIN_ATTENTION_DOOR:string = "bigwinAnticipationDoor";
    

    WIN_LVL:string[] = ["winTiny","winSmall","winMedium","winLarge"];
    HIGHLIGHTWIN_LVL:string[] = ["betlineHighlight","betlinesHighlightSmall","betlinesHighlightMedium","betlinesHighlightLarge"];
    
    SCATTER_LAND:string[] = ["scatter1","scatter2","scatter3","scatter4","scatter5"];
    SCATTER_ATTENTION:string = "scatterAnticipation";
    SCATTER_ATTENTION_MISS:string = "scatterAnticipationFail";

    FS_SCATTER_LAND:string = "scatterFs";

    SCATTER_TO_WILD:string = "scatterToWild";
    SCATTER_TO_WILD_FS:string = "scatterToWildFs";

    FS_PLUS_SPINS:string = "fsPlusSpins";

    REVEAL_RAZOR_BOUNCE:string = "razorbladeLands";

    WILD_LAND:string = "wildLanding";
    WILD_SPLIT:string = "wildSplit";

    WILD_UPGRADE:string = "fsMultiplierUpgrade";
    WILD_EXPLODE:string = "wildExplode";

    WIN_COUNT:string = "countup";

    


    XWAYS_DOUBLE:string = "xWaysDouble";
    XWAYS_SINGLE:string = "xWaysSingle";

    XWAY_REVEAL_SINGLE:string = "xWaysSingleReveal";
    XWAY_REVEAL_DOUBLE:string = "xWaysDoubleReveal";

    CONTINUE_CLICK:string = "continueButton";
    static AS_WIN:string = "asWin";
    static AS_WIN_BIG:string  = "asWinBig";

    
    constructor() {
        if(SoundConfig.instance) {
            throw new Error("SoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}